import { Loading } from '@js/components/common/Loading';
import React from 'react';
import { RadioButtonList } from './RadioButtonList';
import { UseFormRegister } from 'react-hook-form';
import { BankAccountFormData } from '@js/interfaces';

type Props = {
  routeNumList: {
    bankInitials: number
    bankSelect: number
    branchInitials: number
    branchSelect: number
  },
  setRouteNum: React.Dispatch<React.SetStateAction<number>>
  bank_list: {
    id: number
    code: string
    name: string
    name_hira: string
  }[],
  register: UseFormRegister<BankAccountFormData>
  watchRadioButtonBank: string
  onUpdateBankAccount: (key: 'bank_id' | 'branch_id', value: string) => void
  isModalLoading: boolean,
  errors: { [name: string]: object | undefined }
}

export const BankNameSelect = (props: Props) => {
  const { routeNumList, setRouteNum, bank_list, register, watchRadioButtonBank, onUpdateBankAccount, isModalLoading, errors } = props;
  const fieldLabel = 'bank';

  return (
    <>
      <div className="bank-account">
        <div className="bank-account__heading">
          金融機関の選択
        </div>
        {isModalLoading ? (
          <Loading />
        ) : (
          <>
            <div className="bank-account__lead">
              金融機関名を選択してください。
            </div>
            {bank_list.length > 0 ? (
              <ul className="bank-account__list">
                {bank_list ? (
                  <RadioButtonList selectList={bank_list} fieldLabel={fieldLabel} register={register} errors={errors} />
                ) : (
                  <div className="loader" />
                )}
              </ul>
            ):(
              <div className="bank-account__list">
                <p className="bank-account__list-message">
                  当てはまる金融機関名がありません
                </p>
              </div>
            )}
            <div className="layout-flex--center bank-account__button-layout">
              <div className="is-pc">
                <button onClick={() => setRouteNum(routeNumList.bankInitials)} className="button-base--sub button-w182 mr16">
                  前の入力へ戻る
                </button>
              </div>
              <button onClick={() => onUpdateBankAccount('bank_id', watchRadioButtonBank)} type="button" className="button-base--action button-w344">
                支店名の登録に進む
                <i className="material-icons button-icon-right flip-horizontal">keyboard_backspace</i>
              </button>
            </div>
          </>
        )}
      </div>
    </>
  );
};
